

import Component from './component.js';
import createComponentFactory from '../createComponent.js';
import axios from 'axios';
import jsonpAdapter from 'axios-jsonp';

const endpoint = 'https://www.musicland.co.jp/wp-json/wp/v2/event';

class EventFoldedList extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this._page = 2;
    this._perPage = 3;
    this._isLoading = false;
    this._totalPage = +this.element.dataset.totalPage;

    this.list = element.querySelector('.js-foldedList__items');
    this.buttonLoad = element.querySelector('.js-foldedList__more');

    this._handleLoadButtonClick = this._handleLoadButtonClick.bind(this);

  }

  _bindEvents() {

    if(this.buttonLoad) {
      this.buttonLoad.addEventListener('click', this._handleLoadButtonClick);
    }
  }

  _unbindEvents() {

    if(this.buttonLoad) {
      this.buttonLoad.removeEventListener('click', this._handleLoadButtonClick);
    }
  }

  _handleLoadButtonClick(evt) {

    evt.preventDefault();

    if(this._isLoading || this._page > this._totalPage) {
      return;
    }

    const termId = +this.buttonLoad.dataset.termId;

    if(termId === undefined) {
      throw new Error('no term id found');
    }

    const params = {
      page: this._page,
      per_page: this._perPage,
      order: 'asc',
      type: 'report'
    };

    if(termId !== -1) {
      params.event_category = termId;
    }

    this._isLoading = true;

    this.buttonLoad.querySelector('a').classList.add('is-loading');

    axios.get(endpoint, {
      params: params,
      adapter: jsonpAdapter,
      callbackParamName: '_jsonp'
    }).then((res) => {

      this.buttonLoad.querySelector('a').classList.remove('is-loading');

      this._render(res);

      this._page++;
      this._isLoading = false;

      if(this._page > this._totalPage) {
        this._setControlState('complete');
      }
    })
  }


  _render(res) {


    const fragment = document.createDocumentFragment();
    const tmp = document.createElement('div');

    res.data.forEach((entry) => {

      const link = entry.acf.cf_event_link ? entry.acf.cf_event_link : entry.link;

      const dateTmpl = entry.acf.cf_event_desc_date ? `<tr><th>DATE</th><td>${entry.acf.cf_event_desc_date}</td></tr>` : '';
      const placeTmpl = entry.acf.cf_event_desc_place ?`<tr class="u-hiddenSp"><th>PLACE</th><td>${entry.acf.cf_event_desc_place}</td></tr>` : '';
      const priceTmpl = entry.acf.cf_event_desc_price ? `<tr class="u-hiddenSp"><th>PRICE</th><td>${entry.acf.cf_event_desc_price}</td></tr>` : '';
      const shopTmpl = entry.event_shop_name ? entry.event_shop_name.map((name) => {
        return `<li class="event-entry__label__item"><span>${name}</span></li>`;
      }) : '';

      const tmpl = `<li class="event-entry__item">
        <a class="event-entry__link" href="${link}">
          <div class="event-entry__image">
            <img src="${entry.list_thumb}">
          </div>
          <div class="event-entry__text">
            <div class="event-entry__label">
              <ul class="event-entry__label__items">
                ${shopTmpl}
              </ul>
            </div>
            <p class="event-entry__title">${entry.title.rendered}</p>
            <div class="event-entry__description">
              <table>
                <tbody>
                  ${dateTmpl}
                  ${placeTmpl}
                  ${priceTmpl}
                </tbody>
              </table>
            </div>
          </div>
        </a>
      </li>`;

      tmp.innerHTML = tmpl;

      fragment.appendChild(tmp.childNodes[0]);
    });

    this.list.appendChild(fragment);

    this.channel.parent.send((context, payload = {}, done) => {
      context.dispatcher.emit('completeLoadMore');

      if(done) {
        done();
      }
    });
  }

  _setControlState(state) {

    switch(state) {
      case 'complete': {
        if(this.buttonLoad) {
          this.buttonLoad.style.display = 'none';
        }

        break;
      }

      case 'none': {
        if(this.buttonLoad) {
          this.buttonLoad.style.display = '';
        }
        break;
      }
    }
  }

  didRegisterComponent() {
    this._setControlState(this._totalPage > 1 ? 'loadable' : 'complete');
    this._bindEvents();
  }

  didUnregisterComponent() {
    this._setControlState('none');
    this._unbindEvents();
  }

}

export default createComponentFactory(EventFoldedList);



// WEBPACK FOOTER //
// ./src/js/app/component/eventFoldedList.js